import update from 'immutability-helper';

import { ConfigurationAndRights } from '../../../interfaces/ConfigurationAndRights';
import { ConfigurationRight } from '../../../interfaces/ConfigurationRight';
import Store from '../../../interfaces/Store';
import { ValidationAndLightingSetup } from '../../../interfaces/Validation';
import { validationAndLightingSetupReducer } from '../validate/validationAndLightingSetup.reducers';

export const loadConfigurationReducer = (
  store: Store,
  {
    configurationAndRights,
    validationAndLightingSetup,
  }: {
    configurationAndRights: ConfigurationAndRights;
    validationAndLightingSetup: ValidationAndLightingSetup;
  },
) => {
  const { configuration, rights } = configurationAndRights;
  store = update(store, {
    configuration: {
      $set: configuration,
    },
    rights: {
      edit: {
        $set: rights.includes(ConfigurationRight.WRITE),
      },
      request: {
        $set: rights.includes(ConfigurationRight.REQUEST),
      },
    },
  });
  return validationAndLightingSetupReducer(store, validationAndLightingSetup);
};
